import { render } from "./PasswordResetModal.vue?vue&type=template&id=022cdb33&scoped=true"
import script from "./PasswordResetModal.vue?vue&type=script&lang=js"
export * from "./PasswordResetModal.vue?vue&type=script&lang=js"

import "./PasswordResetModal.vue?vue&type=style&index=0&id=022cdb33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022cdb33"]])

export default __exports__